import axios from 'axios'
import config from '../../config'

const APIURL = config.apiUrl;
const HCPURL = config.hcpCmsUrl;

export default {
  listHcp(type) {
    return axios.get(APIURL + 'list/hcp/' + type);
  },
  registerHcp(step, model) {
    return axios.post(APIURL + 'hcp/register/' + step, model);
  },
  uploadVerificationFiles(formData) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    return axios.post(APIURL + 'hcp/register/verify', formData, config);
  },
  getHcpUser() {
    return axios.get(APIURL + 'hcp/user/web');
  },
  getModule(slug) {
    return axios.get(APIURL + 'hcp/posts/' + slug);
  },
  getSimilarModules(post_id, per_page) {
    return axios.get(APIURL + 'hcp/posts/' + post_id + '/similar?per_page=' + per_page);
  },
  getCategories(size) {
    return axios.get(APIURL + 'hcp/categories?size=' + size);
  },
  getModulesByCat(slug, size = 'large') {
    return axios.get(APIURL + 'hcp/category/' + slug + '/posts?size=' + size);
  },
  switchProgram() {
    return axios.put(APIURL + 'hcp/update/program');
  },
  getModules(params) {
    return axios.get(APIURL + 'hcp/posts?' + params);
  },
  getFeaturedCoreModules() {
    return axios.get(APIURL + 'hcp/featured/core-posts');
  },
  getPostsYouMayLike() {
    return axios.get(APIURL + 'hcp/posts-you-may-like');
  },
  getResourceCats() {
    return axios.get(APIURL + 'hcp/resource/cats');
  },
  getResourceCatDownloads(slug) {
    return axios.get(APIURL + 'hcp/resource/cat/' + slug + '/downloads');
  },
  getFeaturedDownloads() {
    return axios.get(APIURL + 'hcp/resource/quick-downloads');
  },
  searchHcp(search, type) {
    return axios.get(APIURL + 'hcp/search/' + search + '?type=' + type);
  },
  acceptHcpWelcome() {
    return axios.put(APIURL + 'hcp/accept-welcome');
  }
}



// WEBPACK FOOTER //
// ./src/api/Hcp/index.js